export default __webpack_public_path__ + "static/media/Sand Strike.6c2e2cf8.png";